// extracted by mini-css-extract-plugin
export default {"container":"styles_container__i9K-4","deleteButton":"styles_deleteButton__4ozMH","backButton":"styles_backButton__1ImMG","applyButton":"styles_applyButton__idk-R"};